export const removeExtraParagraph = (parsedDoc: Document) => {
  const pElements = parsedDoc.querySelectorAll('p')

  pElements.forEach((paragraph) => {
    const classAttribute = paragraph.getAttribute('class')

    if (classAttribute === 'MsoNormal') {
      const fragment = document.createDocumentFragment()
      while (paragraph.firstChild) {
        fragment.appendChild(paragraph.firstChild)
      }
      paragraph.parentNode?.replaceChild(fragment, paragraph)
    }
  })
}
